import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{staticClass:"pa-4"},[_c('div',{staticClass:"Posts mt-8 mb-lg-8"},[_c(VRow,{staticClass:"px-3"},_vm._l((_vm.articles),function(article,index){return _c(VCol,{key:index,staticClass:"pa-0 mb-4",attrs:{"cols":"12","md":"6","lg":"4","xl":"3"}},[_c('ModalPostDetail',{attrs:{"article":article}})],1)}),1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }